export const APP_DOWNLOAD_LINK = 'https://birdwingo.page.link/download';
export const YEARLY_SUBSCRIPTION = 'https://buy.stripe.com/eVacNueE72HD3YYcMN';
export const MONTHLY_SUBSCRIPTION = 'https://buy.stripe.com/3csdRycvZdmhfHG3cg';

export enum StorageKeys {
  ParentAnswers = 'PARENT_ANSWERS',
  ParentAge = 'PARENT_AGE',
  AdultAnswers = 'ADULT_ANSWERS',
  AdultAge = 'ADULT_AGE',
}
